import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('grn_rejection-reasons')
export class GrnRejectionReason {

  @PrimaryGeneratedColumn("increment",{name:'damage_reason_id'})
  rejectionReasonId:number;
 
  @Column("varchar",{
      nullable:false,
      length:40,
      name:"rejection_reason"
      })
      rejectionReason:string;

    @Column("varchar",{
      nullable:true,
      length:50,
      name:"remarks"
      })
    remarks:string;


    @Column("varchar",{
      nullable:false,
      length:50,
      name:"rejection_reason_code"
      })
    rejectionReasonCode : string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
 
}
